module.exports = __webpack_public_path__ + "static/media/result_success.423160eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/result_success.png
// module id = 383
// module chunks = 0